import React from 'react';
import isArray from 'lodash/isArray';
import { Destinations } from '@yme/assets/icons';
import { Image } from '@yme/atoms/image';
import { SVGIcon } from '@yme/atoms/svg-icon';
import { ReadMoreButton } from '@yme/molecules/buttons';
import { useTranslation } from '@yme/services/i18n';
import { colorAccentError600, colorCoreBlack300 } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { RegularTextLevel2, RegularTextLevel3 } from '@yme/tokens/typography';
import { AspectRatio } from '@yme/utils/constants';
import { formatPrice } from '@yme/utils/formatPrice';
import { ElementLinkStyled, ImageWrapperStyled, PriceStyled } from './styled';
export const DestinationCard = ({ cardProps: { image, title, currencyCode, price, location, typeLabel, levelLabel, language, edpURL, expDistance, expDuration, }, converterRate, isRightToLeft, }) => {
    const { t } = useTranslation();
    const levelText = levelLabel.map((l) => t(l)).join(', ');
    const typeLabelText = isArray(typeLabel)
        ? typeLabel.map((item) => t(item.trim())).join(', ')
        : typeLabel
            .split(',')
            .map((item) => t(item.trim()))
            .join(', ');
    const durationAndDistanceText = expDuration || expDistance
        ? `${expDuration ? `${expDuration} ${t('common_days_label')}` : ''}
          ${expDuration && expDistance ? '/' : ''}
          ${expDistance ? `${expDistance} ${t('common_km_label')}` : ''}`
        : '';
    const isDurationAndDistanceExist = Boolean(durationAndDistanceText);
    return (React.createElement("div", null,
        React.createElement(ElementLinkStyled, { to: edpURL },
            React.createElement(ImageWrapperStyled, null,
                React.createElement(Image, { ...image, objectFit: "cover", aspectRatio: AspectRatio.RectangleLevel3 }))),
        React.createElement(ElementLinkStyled, { to: edpURL },
            React.createElement(RegularTextLevel2, { weight: 500, as: "span" }, title)),
        React.createElement(PriceStyled, { color: colorCoreBlack300 }, `${t('destinations_experienceStartingPrice_label')} ${formatPrice({
            locale: language,
            currencyName: currencyCode,
            price,
            converterRate,
        })}`),
        React.createElement(FlexWrapper, { gap: "16px", mt: "12px" },
            React.createElement(SVGIcon, { type: Destinations.Location, pathFill: colorAccentError600 }),
            React.createElement(RegularTextLevel3, null, location)),
        React.createElement(FlexWrapper, { gap: "16px", mt: "8px" },
            React.createElement(SVGIcon, { type: Destinations.Road }),
            React.createElement(RegularTextLevel3, null, typeLabelText)),
        React.createElement(FlexWrapper, { gap: "16px", mt: "8px", mb: !isDurationAndDistanceExist ? '16px' : undefined },
            React.createElement(SVGIcon, { type: Destinations.Star }),
            React.createElement(RegularTextLevel3, null, levelText)),
        Boolean(durationAndDistanceText) && (React.createElement(FlexWrapper, { gap: "16px", mt: "8px", mb: "16px" },
            React.createElement(SVGIcon, { type: Destinations.Calendar }),
            React.createElement(RegularTextLevel3, null, durationAndDistanceText))),
        React.createElement(ReadMoreButton, { toRoute: edpURL, isRightToLeft: isRightToLeft, labelLink: t('common_readMore_link') })));
};
DestinationCard.displayName = 'DestinationCard_Molecule';
